export default "__VITE_ASSET__BOVALNo7__"